import { render, staticRenderFns } from "./LmBlueprintNewOrEdit.vue?vue&type=template&id=245c1caf&scoped=true"
import script from "./LmBlueprintNewOrEdit.vue?vue&type=script&lang=js"
export * from "./LmBlueprintNewOrEdit.vue?vue&type=script&lang=js"
import style0 from "./LmBlueprintNewOrEdit.vue?vue&type=style&index=0&id=245c1caf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245c1caf",
  null
  
)

export default component.exports